import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { noop } from 'lodash/noop';
import { SuiContainer, SuiLabel, SuiField } from '@splashthat/sui';

import BorderPickerOptionsPopover from './BorderPickerOptionsPopover';

import Settings from '../../../icons/Settings';
import './styles.styl';

const BORDER_PICKER_TITLE = 'Border';

const BASE_CLASS_NAME = 'BorderPickerOptions';

export default class BorderPickerOptions extends Component {
    static propTypes = {
        getAnchorEl: PropTypes.func,
        getRefWidth: PropTypes.func,
        borderRadius: PropTypes.number,
        onBorderRadiusChanged: PropTypes.func,
        borderWidths: PropTypes.object,
        onChangeTopBorderWidth: PropTypes.func,
        onChangeBottomBorderWidth: PropTypes.func,
        onChangeRightBorderWidth: PropTypes.func,
        onChangeLeftBorderWidth: PropTypes.func,
        qaId: PropTypes.string.isRequired,
        componentLabel: PropTypes.string,
    };

    static defaultProps = {
        getAnchorEl: noop,
        getRefWidth: noop,
        onBorderRadiusChanged: noop,
        borderRadius: 0,
        borderWidths: {},
        onChangeTopBorderWidth: noop,
        onChangeBottomBorderWidth: noop,
        onChangeRightBorderWidth: noop,
        onChangeLeftBorderWidth: noop,
        onChangeAllBordersUp: noop,
        onChangeAllBordersDown: noop,
        componentLabel: '',
    };

    state = {
        popoverIsVisible: false,
    };

    showPopover = () => {
        this.setState({
            popoverIsVisible: !this.state.popoverIsVisible,
        });
    };

    showBorderOptionsPopover = () => (
        <BorderPickerOptionsPopover
            showPopover={this.state.popoverIsVisible}
            onClickClose={this.showPopover}
            anchorEl={this.props.getAnchorEl()}
            minWidth={this.props.getRefWidth()}
            borderRadius={this.props.borderRadius}
            onBorderRadiusChanged={this.props.onBorderRadiusChanged}
            borderWidths={this.props.borderWidths}
            onChangeTopBorderWidth={this.props.onChangeTopBorderWidth}
            onChangeBottomBorderWidth={this.props.onChangeBottomBorderWidth}
            onChangeRightBorderWidth={this.props.onChangeRightBorderWidth}
            onChangeLeftBorderWidth={this.props.onChangeLeftBorderWidth}
            qaId={`${this.props.qaId}--popover`}
        />
    );

    render() {
        const { popoverIsVisible } = this.state;
        const { qaId, componentLabel } = this.props;

        return (
            <SuiContainer className={`${BASE_CLASS_NAME}__container`}>
                <SuiLabel text={`${componentLabel} ${BORDER_PICKER_TITLE}`} />
                <SuiField
                    className={`${BASE_CLASS_NAME}__container--settings`}
                    formElement={
                        <button
                            className={`${BASE_CLASS_NAME}__container--button`}
                            onClick={this.showPopover}
                            data-qa={`${qaId}--settings`}
                        >
                            <Settings />
                        </button>
                    }
                />
                {popoverIsVisible ? this.showBorderOptionsPopover() : null}
            </SuiContainer>
        );
    }
}
